import { render, staticRenderFns } from "./Surgeon.vue?vue&type=template&id=222da762&scoped=true&"
import script from "./Surgeon.vue?vue&type=script&lang=js&"
export * from "./Surgeon.vue?vue&type=script&lang=js&"
import style0 from "./Surgeon.vue?vue&type=style&index=0&id=222da762&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "222da762",
  null
  
)

export default component.exports